<template>
  <div class="register" :style="{minHeight: getHeight  + 'px'}">
    <div class="register-view" v-if="!success">
      <h4>会员注册</h4>
      <form class="register-form">
        <input v-model="email" type="email" placeholder="请输入工作邮箱">
        <input v-model="password" type="password" placeholder="请输入密码">
        <input v-model="name" type="text" placeholder="请输入姓名">
        <input v-model="company" type="text" placeholder="请输入公司">
        <input type="button" value="确认申请" @click="register">
      </form>
    </div>
    <div class="result-view" v-else>
      <i class="right-icon"></i>
      <span>申请成功！</span>
      <span>我们将尽快审核您的申请！</span>
    </div>
  </div>
</template>

<script>
const mailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/
export default {
  components: {},
  props: {},
  data () {
    return {
      email: '',
      password: '',
      name: '',
      company: '',
      success: false,
    }
  },
  computed: {
    getHeight () {
      return window.innerHeight - 130
    }
  },
  methods: {
    register () {
      if(!this.email || !this.password || !this.name || !this.company) {
        alert('请填写完整信息！')
      } else if (!mailReg.test(this.email)) {
        alert('邮箱格式不正确！')
      } else {
        this.success = true
      }
    }
  }
}
</script>
<style scoped>
.register {
  background-size: cover;
  background-image: url('../assets/banner.png');
  background-position: center;
  position: relative;
}
.register-view, .result-view {
  width: 350px;
  height: 442px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -175px;
  margin-top: -221px;
  border-radius: 6px;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, .06);
  padding: 40px 0 0;
  text-align: center;
  font-size: 18px;
}
.register-view h4 {
  margin-bottom: 20px;
}
.register-form input {
  display: block;
  width: 300px;
  height: 40px;
  margin: 0 auto;
  background-color: #f2f2f2;
  margin-top: 12px;
  border-radius: 2px;
  text-align: center;
}
.register-form input[type="button"] {
  background-color: #006191;
  color: #fff;
  margin: 68px auto 10px;
  cursor: pointer;
}
.register-form input::placeholder {
  text-align: center;
  font-size: 14px;
}
.result-view i {
  display: block;
  width: 72px;
  height: 72px;
  margin: 50px auto;
  background-image: url('../assets/right.png')
}
.result-view span {
  display: block;
  text-indent: 16px;
}
.result-view span:nth-child(2) {
  font-size: 24px;
  color: #006191;
}
.result-view span:last-child {
  color: #666;
  margin-top: 12px;
}

</style>